module.exports = __webpack_public_path__ + "img/benefit.a7844b7f.png";